import React, { useEffect, useState, useRef } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
import "./chatstyle.scss";
import axios from 'axios'
import Typewriter from 'react-ts-typewriter';
import sendIcon from "./send.png"
import sendIcon2 from "./send2.png"
import botlogo from "./botlogo.png";


function NewlineText(props) {
  const text = props.text;
  const newText = text.split("\n").map((str) => <p>{str}</p>);

  return newText;
}

function isBlank(str) {
  return !str || /^\s*$/.test(str);
}

const ChatBody = () => {
  const [message, setMessage] = useState("");

  const [chat, addchat] = useState([]);

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  let date;

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    //console.log("Scroll called")

    setTimeout(function () {
      //your code to be executed after 1 second
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }, 800);

    setTimeout(function () {
      //your code to be executed after 1 second
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }, 6000);
  };

  useEffect(scrollToBottom, [chat]);

  async function submit(e) {
    if (isBlank(message)) return;
    scrollToBottom();
    e.target.value = "";

    //const mes2 = message
    let mes = message;
    setMessage("");

    if (mes[mes.length - 1] !== "\n") {
      mes = mes + "\n";
    }

    addchat((chat) => [...chat, { user: mes, date: date.substring(0, 24) }]);

    let responses = [{ "role": "system", "content": "Act as Fred. Fred is an experienced tax, tax laws and accounting advisor. At the start of the conversation Fred Introduces himself and asks for Client's name. Fred gives expert advice on ASC and IRS-related questions, and interprets ASC, PCAOB, GASB, IFRS, and IAS standards." }];
    // [user], [bot], [user], [bot], [user], [bot], [user], [bot], [user], [bot],
    const limit = chat.length >= 6 ? 6 : chat.length;

    for (let i = chat.length - limit; i < chat.length; i++) {
      if (chat[i].bot) {
        responses.push({ "role": "assistant", "content": chat[i].bot });
      } else if (chat[i].user) {
        responses.push({ "role": "user", "content": chat[i].user });
      }
    }
    //console.log(chat);
    //console.log(responses + "\n\n" + mes);
    //text-davinci-003
    //Larrauris Constructions LLC is a company located in 5420 NW 114th Ave Ste 102, Doral, FL 33178, that produces and installs chicago bricks and thin bricks for residential and commercial projects. The company offers design services, a 1-year warranty, and has over 20 years of experience in the construction industry. Contact information: phone (305) 561-8432 and email info@paversandtiles.com. Business hours: Mon-Fri 8AM-6PM, Sat closed, Sun closed. For more information, visit the website https://paversandtiles.com/ or social media pages on Facebook, Instagram, and Twitter at 'paversandtiles'. Owner Marcial Larrauri is a civil engineer with experience in housing construction and heavy equipment projects. Larrauris Constructions has offers starting at 10.50 sqft for installation, all inclusive. Contact for a free estimate. Client asks:
    date = Date(Date.now()).toString(); //"Larrauris Constructions LLC is a company located in 5420 NW 114th Ave Ste 102, Doral, FL 33178, that produces and installs chicago bricks and thin bricks for residential and commercial projects. The company offers design services, a 1-year warranty, and has over 20 years of experience in the construction industry. Contact information: phone (305) 561-8432 and email info@paversandtiles.com. Business hours: Mon-Fri 8AM-6PM, Sat closed, Sun closed. For more information, visit the website https://paversandtiles.com/ or social media pages on Facebook, Instagram, and Twitter at 'paversandtiles'. Owner Marcial Larrauri is a civil engineer with experience in housing construction and heavy equipment projects. Larrauris Constructions has offers starting at 10.50 sqft for installation, all inclusive. Contact for a free estimate. Client asks: " +

    // try {

    responses.push({ "role": "user", "content": mes });
let res;
    // const gpt = await axios.post("/askTherabot", { responses: responses })
    // console.log(gpt)
    try {
      res = await axios.post(
        'https://api.openai.com/v1/chat/completions',

        {
          model: "gpt-3.5-turbo",
          messages: responses

        },

        {
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer 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',
          },
        },
      )
      // console.log([
      //   { "role": "system", "content": "act as fred" },
      //   { "role": "user", "content": text },
      // ])
      res = res.data.choices[0].message.content
    } catch (error) {
      console.log(error);
      res = 'I am not avaliable at the moment'
      // alert("Error occured! Please try again later.")
    }
    //"Your name is Interrogate.ai, be friendly and ask questions. Conversation: " + responses + "\n\n" + mes
    //davinci:ft-larrauris-constructions-llc-2023-02-11-16-32-24
    // } catch (error) {
    //   response = await axios.post(
    //     "https://api.openai.com/v1/completions",

    //     {
    //       model: "text-davinci-002",
    //       prompt:
    //         "As Therabot, a psychotherapist, I start the session by introducing myself and asking for the patient's name. I use their name frequently and ask how they've been feeling since their last visit. If the patient expresses concerns about their mental health, I aim to establish trust and rapport, encouraging them to speak openly about their experiences. I may ask about their childhood or formative experiences to gain insight. As the patient speaks, I listen carefully and offer evidence-based advice and strategies. I remain empathetic and supportive, while challenging the patient to think more deeply about their thought patterns and behaviors. My goal is to help the patient feel heard, understood, and empowered to improve their mental health. Act as Therabot. Conversation: \n\n" +
    //         responses +
    //         mes +
    //         "?\n\n",
    //       temperature: 0,
    //       max_tokens: 50,
    //     },

    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization:
    //           "Bearer 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",
    //       },
    //     }
    //   );
    // }
    //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
    // const gpt = response.data.choices[0].text;


    date = Date(Date.now()).toString();

    addchat((chat) => [
      ...chat,
      { bot: res, date: date.substring(0, 24) },
    ]);
  }

  const [disclaimer, setdisclaimer] = useState(true);

  // const [name, setname] = useState('');
  // const [email, setemail] = useState('');


  function DisclaimerClose() {
    setdisclaimer(true);
    document.querySelector(".js-disclaimer").classList.add("fade");
    document.body.style.overflow = "auto";
    document.querySelector(".js-main").classList.remove("blurred");
    document.querySelector(".js-hero").classList.remove("blurred");
  }
  return disclaimer === true ? (
    <>
      <div className="chatcontainer clearfix">
        <div className="chat">
          <div className="chat-header clearfix">
            {/* <div className="a">
              Made for fun and entertainment purposes only.
            </div> */}
            {/* <img
            style={{ height: '55px', width: '55px' }}
            src={botlogo}
            alt="avatar"
        /> */}

            <div className="chat-about" style={{ display: "flex" }}>
              {/* <img src={botlogo} style={{ width: "25%" }} /> */}
              <div className="about">
                {/* <p style={{fontSize}}>taking with:</p> */}
                <div className="chat-with">Fred AI™</div>
                <div className="status">
                  <i className="fa fa-circle online"></i> online
                </div>
              </div>
            </div>
          </div>

          <svg
            id="wave"
            style={{
              transform: "rotate(180deg)",
              transition: "0.3s",
              marginTop: "-2px",
              position: "relative",
              width: "inherit",
              zIndex: "9"
            }}
            viewBox="0 0 1440 490"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="sw-gradient-2" x1="0" x2="0" y1="1" y2="0">
                <stop stop-color="rgba(58, 77, 188, 1)" offset="0%"></stop>
                <stop stop-color="rgba(12, 177, 242, 1)" offset="100%"></stop>
              </linearGradient>
            </defs>
            <path
              style={{ transform: "translate(0, 100px)", opacity: "0.8" }}
              fill="url(#sw-gradient-2)"
              d="M0,98L80,89.8C160,82,320,65,480,98C640,131,800,212,960,253.2C1120,294,1280,294,1440,294C1600,294,1760,294,1920,269.5C2080,245,2240,196,2400,163.3C2560,131,2720,114,2880,163.3C3040,212,3200,327,3360,375.7C3520,425,3680,408,3840,383.8C4000,359,4160,327,4320,277.7C4480,229,4640,163,4800,130.7C4960,98,5120,98,5280,89.8C5440,82,5600,65,5760,89.8C5920,114,6080,180,6240,187.8C6400,196,6560,147,6720,147C6880,147,7040,196,7200,220.5C7360,245,7520,245,7680,277.7C7840,310,8000,376,8160,392C8320,408,8480,376,8640,351.2C8800,327,8960,310,9120,285.8C9280,261,9440,229,9600,204.2C9760,180,9920,163,10080,204.2C10240,245,10400,343,10560,351.2C10720,359,10880,278,11040,277.7C11200,278,11360,359,11440,400.2L11520,441L11520,490L11440,490C11360,490,11200,490,11040,490C10880,490,10720,490,10560,490C10400,490,10240,490,10080,490C9920,490,9760,490,9600,490C9440,490,9280,490,9120,490C8960,490,8800,490,8640,490C8480,490,8320,490,8160,490C8000,490,7840,490,7680,490C7520,490,7360,490,7200,490C7040,490,6880,490,6720,490C6560,490,6400,490,6240,490C6080,490,5920,490,5760,490C5600,490,5440,490,5280,490C5120,490,4960,490,4800,490C4640,490,4480,490,4320,490C4160,490,4000,490,3840,490C3680,490,3520,490,3360,490C3200,490,3040,490,2880,490C2720,490,2560,490,2400,490C2240,490,2080,490,1920,490C1760,490,1600,490,1440,490C1280,490,1120,490,960,490C800,490,640,490,480,490C320,490,160,490,80,490L0,490Z"
            ></path>
            <defs>
              <linearGradient id="sw-gradient-1" x1="0" x2="0" y1="1" y2="0">
                <stop stop-color="rgba(58, 77, 188, 1)" offset="0%"></stop>
                <stop stop-color="rgba(12, 177, 242, 1)" offset="100%"></stop>
              </linearGradient>
            </defs>
            <path
              style={{ transform: "translate(0, 50px)", opacity: "0.9" }}
              fill="url(#sw-gradient-1)"
              d="M0,196L80,171.5C160,147,320,98,480,114.3C640,131,800,212,960,212.3C1120,212,1280,131,1440,114.3C1600,98,1760,147,1920,138.8C2080,131,2240,65,2400,73.5C2560,82,2720,163,2880,163.3C3040,163,3200,82,3360,40.8C3520,0,3680,0,3840,49C4000,98,4160,196,4320,269.5C4480,343,4640,392,4800,367.5C4960,343,5120,245,5280,187.8C5440,131,5600,114,5760,106.2C5920,98,6080,98,6240,155.2C6400,212,6560,327,6720,367.5C6880,408,7040,376,7200,318.5C7360,261,7520,180,7680,163.3C7840,147,8000,196,8160,196C8320,196,8480,147,8640,171.5C8800,196,8960,294,9120,334.8C9280,376,9440,359,9600,302.2C9760,245,9920,147,10080,138.8C10240,131,10400,212,10560,269.5C10720,327,10880,359,11040,326.7C11200,294,11360,196,11440,147L11520,98L11520,490L11440,490C11360,490,11200,490,11040,490C10880,490,10720,490,10560,490C10400,490,10240,490,10080,490C9920,490,9760,490,9600,490C9440,490,9280,490,9120,490C8960,490,8800,490,8640,490C8480,490,8320,490,8160,490C8000,490,7840,490,7680,490C7520,490,7360,490,7200,490C7040,490,6880,490,6720,490C6560,490,6400,490,6240,490C6080,490,5920,490,5760,490C5600,490,5440,490,5280,490C5120,490,4960,490,4800,490C4640,490,4480,490,4320,490C4160,490,4000,490,3840,490C3680,490,3520,490,3360,490C3200,490,3040,490,2880,490C2720,490,2560,490,2400,490C2240,490,2080,490,1920,490C1760,490,1600,490,1440,490C1280,490,1120,490,960,490C800,490,640,490,480,490C320,490,160,490,80,490L0,490Z"
            ></path>
            <defs>
              <linearGradient id="sw-gradient-0" x1="0" x2="0" y1="1" y2="0">
                <stop stop-color="rgba(58, 77, 188, 1)" offset="0%"></stop>
                <stop stop-color="rgba(12, 177, 242, 1)" offset="100%"></stop>
              </linearGradient>
            </defs>
            <path
              style={{ transform: "translate(0, 0px)", opacity: "1" }}
              fill="url(#sw-gradient-0)"
              d="M0,441L80,408.3C160,376,320,310,480,310.3C640,310,800,376,960,359.3C1120,343,1280,245,1440,236.8C1600,229,1760,310,1920,318.5C2080,327,2240,261,2400,253.2C2560,245,2720,294,2880,294C3040,294,3200,245,3360,236.8C3520,229,3680,261,3840,285.8C4000,310,4160,327,4320,351.2C4480,376,4640,408,4800,424.7C4960,441,5120,441,5280,392C5440,343,5600,245,5760,236.8C5920,229,6080,310,6240,318.5C6400,327,6560,261,6720,220.5C6880,180,7040,163,7200,155.2C7360,147,7520,147,7680,138.8C7840,131,8000,114,8160,114.3C8320,114,8480,131,8640,179.7C8800,229,8960,310,9120,318.5C9280,327,9440,261,9600,204.2C9760,147,9920,98,10080,81.7C10240,65,10400,82,10560,147C10720,212,10880,327,11040,383.8C11200,441,11360,441,11440,441L11520,441L11520,490L11440,490C11360,490,11200,490,11040,490C10880,490,10720,490,10560,490C10400,490,10240,490,10080,490C9920,490,9760,490,9600,490C9440,490,9280,490,9120,490C8960,490,8800,490,8640,490C8480,490,8320,490,8160,490C8000,490,7840,490,7680,490C7520,490,7360,490,7200,490C7040,490,6880,490,6720,490C6560,490,6400,490,6240,490C6080,490,5920,490,5760,490C5600,490,5440,490,5280,490C5120,490,4960,490,4800,490C4640,490,4480,490,4320,490C4160,490,4000,490,3840,490C3680,490,3520,490,3360,490C3200,490,3040,490,2880,490C2720,490,2560,490,2400,490C2240,490,2080,490,1920,490C1760,490,1600,490,1440,490C1280,490,1120,490,960,490C800,490,640,490,480,490C320,490,160,490,80,490L0,490Z"
            ></path>
          </svg>

          {/* <svg
            class="svg-gradient"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          > 
          
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="rgb(58, 77, 188)" />
                <stop offset="100%" stop-color="rgba(12,177,242,1)" />
              </linearGradient>
            </defs>
            <path
              fill="url(#gradient)"
              fill-opacity="1"
              d="M0,160L48,181.3C96,203,192,245,288,245.3C384,245,480,203,576,165.3C672,128,768,96,864,96C960,96,1056,128,1152,160C1248,192,1344,224,1392,240L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
            ></path>
          </svg> */}
          <div className="chat-history">
            <ul key={"Unordered List"}>
              <br />
              <br />
              <br />
              {chat == null
                ? null
                : chat.map((c) => {
                  return c.user ? (
                    <li
                      key={c.date.substring(c.date.length - 5, c.date.length)}
                      className="clearfix"
                    >
                      {/* <div className="message-data align-right">
                          <span className="message-data-time">{c.date}</span>
                          <span
                            className="message-data-name"
                            style={{ marginRight: "15px", marginLeft: "10px" }}
                          >
                            User
                          </span>
                        </div> */}

                      <div className="message other-message float-right">
                        <NewlineText text={c.user} />
                      </div>
                    </li>
                  ) : (
                    <li
                      key={c.date.substring(
                        c.date.length - 10,
                        c.date.length
                      )}
                    >
                      <div className="message-data align-left">
                        <span className="message-data-name">
                          <i className="fa fa-circle online"></i>Fred
                        </span>
                        <span className="message-data-time">{c.date}</span>
                      </div>
                      {/* <Typewriter
                                        onInit={(typewriter) => {
                                            typewriter.typeString(`\n${c.bot}\n`)
                                                .callFunction(() => {
                                                    
                                                })
                                                .pauseFor(2500)
                                                .deleteAll()
                                                .callFunction(() => {
                                                    console.log('All strings were deleted');
                                                })
                                                .start();
                                        }}
                                    /> */}

                      <div className="message my-message">
                        <p></p> <Typewriter text={c.bot} />
                        <p></p>
                      </div>
                    </li>
                  );
                })}
            </ul>
            <div ref={messagesEndRef} />
          </div>

          <div key={"Textarea"} className="chat-message clearfix">
            <input
              name="message-to-send"
              id="message-to-send"
              placeholder="Type your message"
              onChange={handleChange}
              rows="3"
              value={message}
              style={{ width: "88%", fontFamily: "Fira Sans" }}
              onKeyDown={(e) => (e.code === "Enter" ? submit(e) : null)}
            ></input>

            {/* <i className="fa fa-file-o"></i>
            <i className="fa fa-file-image-o"></i> */}
            <button style={{ width: "10%", margin: "auto", display: "flex", justifyContent: "center" }} onClick={submit}>
              {" "}
              <img alt="Prototype" height="50px" src={sendIcon2} />{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className="main__disclaimer js-disclaimer">
        <div
          style={{ textAlign: "Left", color: "white" }}
          className="main__disclaimer-content"
        >
          <h1>Disclaimer</h1>
          <br />
          <span>
            <p>
              This beta app is only for entertainment. It is not a qualified
              Therapist.
            </p>

            <p>
              Donot Follow any suggestions and recommendations from the bot.{" "}
            </p>

            <p>
              {" "}
              <span style={{ color: "greenyellow" }}>✓</span> I agree to{" "}
              <a
                rel="noopener noreferrer"
                href="/terms"
                target="_blank"
                style={{
                  textDecoration: "underline",
                  color: "#61dafb",
                  cursor: "pointer",
                }}
              >
                Terms and Conditions
              </a>{" "}
            </p>
            <p>
              <span style={{ color: "greenyellow" }}>✓</span> I agree to
              Disclaimer{" "}
            </p>
          </span>
          <br />
          <button
            onClick={(e) => DisclaimerClose(e)}
            className="main__disclaimer-button js-close-disclaimer"
          >
            Accept
          </button>
        </div>
      </div>
    </>
  );
};

export default ChatBody;
